import { useState } from "react";
import { Link } from "react-router-dom";
import { Copy, Lock, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../../context/LanguageContext";
import { Item } from "../Reveal";
import { RegistrationModal } from "./RegistrationForm";

export const copyOpportunityLink = (id, message) => {
  const url = `${window.location.origin}/opportunities/${id}`;
  navigator.clipboard?.writeText(url);
  toast.success(message, { description: url });
};

export const OpportunityCard = ({ opp }) => {
  const { t, rtl } = useLang();
  const [open, setOpen] = useState(false);
  const isFull = opp.status !== "open" || opp.remaining_seats <= 0;
  const pct = Math.max(0, Math.min(100, ((opp.total_seats - opp.remaining_seats) / opp.total_seats) * 100));
  const limited = !isFull && opp.remaining_seats <= 3;

  return (
    <Item className={`opp-card ${isFull ? "full" : ""}`} data-testid={`opportunity-card-${opp.id}`}>
      <div className="opp-top">
        <div className="opp-specialty"><span className="badge badge-indigo">{rtl ? opp.specialty_ar : opp.specialty_en}</span><small style={{ display: "block", marginTop: 6 }}>{rtl ? opp.specialty_en : opp.specialty_ar}</small></div>
        {isFull ? <span className="badge badge-muted"><Lock size={12} />{t.opps.full}</span> : opp.featured ? <span className="badge badge-gold">{t.opps.featured}</span> : limited ? <span className="badge badge-hot">🔥 {t.opps.limited}</span> : null}
      </div>
      <Link to={`/opportunities/${opp.id}`}><h3 className="opp-title">{opp.title_en}</h3></Link>
      {opp.title_ar && rtl && <p className="opp-title-ar">{opp.title_ar}</p>}
      {!isFull && <>
        <div className="opp-note">{t.opps.note} 🏆</div>
        <div className="opp-price">{opp.price_note}</div>
        <div className="seat-text">{t.opps.remain} <b className={limited ? "" : "ok"}>{opp.remaining_seats}</b> {t.opps.seatsLeft} <b style={{ color: "var(--text)" }}>{opp.total_seats}</b>!</div>
        <div className="seat-bar"><i style={{ width: `${pct}%` }} /></div>
      </>}
      {isFull ? <div className="opp-full-lock"><Lock size={15} />{t.opps.full}</div> : (
        <div className="opp-actions">
          <button className="btn btn-primary" onClick={() => setOpen(true)} data-testid={`opportunity-register-${opp.id}`}><UserPlus size={17} />{t.opps.register}</button>
          <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
            <Link to={`/opportunities/${opp.id}`} className="link-btn" data-testid={`opportunity-details-${opp.id}`}>{t.opps.details}</Link>
            <button className="link-btn" onClick={() => copyOpportunityLink(opp.id, t.opps.copied)} data-testid={`opportunity-copy-link-${opp.id}`}><Copy size={12} />{t.opps.copyLink}</button>
          </div>
        </div>
      )}
      {open && <RegistrationModal opp={opp} onClose={() => setOpen(false)} />}
    </Item>
  );
};
